  <div class="pathways-left-side">
    <ng-content class="pathways-selections-title"></ng-content>
    <ispm-generic-list [items$]="items$" [maxHeight]="'45vh'"></ispm-generic-list>
  </div>


